import { useEffect } from "react";
import { useUnload } from "../CustomHooks";

interface IWarningModal {
  displayModal: boolean;
  setCloseWarning: (warningMessage: string) => void;
  // Optional warning message, default will be used if not assigned.
  warningMessage?: string;
}

export const WarningModal = (props: IWarningModal): JSX.Element => {
  const { warningMessage, displayModal, setCloseWarning } = props;

  // Browser modal that will popup if users attempt to close browser window with unsaved changes.
  // Format of this function is defined here https://www.tabnine.com/code/javascript/functions/builtins/BeforeUnloadEvent/preventDefault
  useUnload((ev: BeforeUnloadEvent) => {
    ev.preventDefault();
    ev.returnValue = ""; // Chrome requires returnValue to be set otherwise window closes
    return "?"; // Older browsers need string to be returned
  }, displayModal);

  // Application modal that will popup if users attempt to close mosaic window with unsaved changes.
  useEffect(() => {
    if (setCloseWarning && typeof setCloseWarning === "function") {
      const message = warningMessage ?? "Closing this window might result in loss of unsaved changes.";
      // console.log("displayModal", displayModal);
      setCloseWarning(displayModal ? message : null);
    }
  }, [displayModal, setCloseWarning, warningMessage]);

  // Doesn't return an actual component.
  return null;
};
